module.exports = __webpack_public_path__ + "fonts/d5a0f73bbff05796a346839b62d6b3f1.svg";